import React from 'react'

const _subscribeForm = `
<!-- Begin Mailchimp Signup Form -->
<link href="//cdn-images.mailchimp.com/embedcode/classic-071822.css" rel="stylesheet" type="text/css">
<style type="text/css">
	#mc_embed_signup{background:#fff; clear:left; font:14px Helvetica,Arial,sans-serif;  width:600px;}
	/* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
	   We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */
</style>
<div id="mc_embed_signup">
    <form action="https://thebitcoinmart.us13.list-manage.com/subscribe/post?u=f5716bf2284f8c05c59702bfa&amp;id=72a725b5cd&amp;f_id=007dc1e2f0" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
        <div id="mc_embed_signup_scroll">
        <h2>Subscribe</h2>
        <div class="indicates-required"><span class="asterisk">*</span> indicates required</div>
<div class="mc-field-group">
	<label for="mce-EMAIL">Email Address  <span class="asterisk">*</span>
</label>
	<input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL" required>
	<span id="mce-EMAIL-HELPERTEXT" class="helper_text"></span>
</div>
	<div id="mce-responses" class="clear foot">
		<div class="response" id="mce-error-response" style="display:none"></div>
		<div class="response" id="mce-success-response" style="display:none"></div>
	</div>    <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
    <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_f5716bf2284f8c05c59702bfa_72a725b5cd" tabindex="-1" value=""></div>
        <div class="optionalParent">
            <div class="clear foot">
                <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button">
                <p class="brandingLogo"><a href="http://eepurl.com/iafV9n" title="Mailchimp - email marketing made easy and fun"><img src="https://eep.io/mc-cdn-images/template_images/branding_logo_text_dark_dtp.svg"></a></p>
            </div>
        </div>
    </div>
</form>
</div>
<script type='text/javascript' src='//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'></script><script type='text/javascript'>(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[5]='BIRTHDAY';ftypes[5]='birthday';}(jQuery));var $mcj = jQuery.noConflict(true);</script>
<!--End mc_embed_signup-->
`;

export const SubscribeForm = () => {
	return (
		<div className="bitcoinmart-subscribe-form" dangerouslySetInnerHTML={{ __html: _subscribeForm }} />
	)
}

export const ContactForm = () => {
	return (
		<iframe
			style={{ overflow: 'hidden', width: '100%', height: '1200px' }}
			title="Mailchimp Contact Form"
			src='https://us13.list-manage.com/contact-form?u=f5716bf2284f8c05c59702bfa&form_id=7cfa4c785cb787fe781bbf0f08f5f442'
		/>
	)

}

export const BusinessContactForm = () => {
	return (
		<iframe
			style={{ overflow: 'hidden', width: '100%', height: '1400px' }}
			// className="bitcoinmart-business-contact-form"
			title="Mailchimp Business Contact Form"
			src="https://thebitcoinmart.us13.list-manage.com/subscribe?u=f5716bf2284f8c05c59702bfa&id=72a725b5cd"
		/>
	)
}

